const { NODE_ENV } = process.env
const { hostname } = window.location

const servers = {
  local: "http://localhost:5031",
  customDev: "https://react.customdev.solutions:5031",
  live: "https://predivauthmarketplace.com:5031"
}

var URL;
if (NODE_ENV === "production" && hostname.includes("react.customdev.solutions")) URL = servers.customDev
else if (NODE_ENV === "production" && hostname.includes("predivauthmarketplace.com")) URL = servers.live
else URL = servers.local

export const connection_string = `${URL}/api/v1`
export const image_url = `${URL}/`

console.log("URL: ", URL , "connection_string",connection_string)

// export let connection_string;
// export let image_url;
// export let vendor_register;
// export let vendor_login;

// if (window.location.hostname == "localhost") {
//   connection_string = "http://localhost:5030/api/v1";
//   image_url = "http://localhost:5030/";
//   vendor_register = "https://predivauth.com/predivauth/predivauthendor/register";
//   vendor_login = "https://predivauth.com/predivauth/predivauthendor";
// }else {
  // connection_string = URL + "/api/v1";
  // image_url = URL + "/";
  // vendor_register = "https://predivauth.com/predivauth/predivauthendor/register";
  // vendor_login = "https://predivauth.com/predivauth/predivauthendor";
// }
